import { useCallback, useEffect } from 'react';

export const useUpdateDocumentClass = (className: string) => {
  return useCallback(
    (shouldApply: boolean) => {
      if (typeof document === 'undefined') {
        return;
      }

      if (shouldApply) {
        document.documentElement?.classList.add(className);
      } else {
        document.documentElement?.classList.remove(className);
      }
    },
    [className]
  );
};

export const useDocumentClassWhileRendered = (className: string) => {
  const updateDocumentClass = useUpdateDocumentClass(className);

  useEffect(() => {
    updateDocumentClass(true);

    return () => {
      updateDocumentClass(false);
    };
  }, [updateDocumentClass]);
};
